/* eslint-disable import/prefer-default-export */
import pdfMake from 'addthaifont-pdfmake/build/pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import _ from 'lodash';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import THBText from 'thai-baht-text';

import currencyFormatterTH from '../../utils/functions/currencyFormatterTH';
import { ReportHeader } from './common';
import { PAYROLL_TYPE } from '../../utils/constants';

dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

pdfMake.fonts = {
  Sarabun: {
    normal: 'Sarabun-Light.ttf',
    bold: 'Sarabun-Regular.ttf',
    italics: 'Sarabun-LightItalic.ttf',
    bolditalics: 'Sarabun-Italic.ttf',
  },
};

export const EmployeePayrollReport = (
  employees,
  information,
  option = {
    startDate: '',
    endDate: '',
    payroll_type: '',
    filterUsingDate: false,
    selectedDate: '',
  },
  isError,
) => {
  const genEmployee = (data) =>
    _.map(data, (_data, index) => [
      {
        text: index + 1,
        border: [true, false, true, true],
        fontSize: 10,
        colSpan: 1,
        alignment: 'center',
      },
      {
        text: `${_data?.firstname || ''} ${_data?.lastname || ''}`,
        border: [true, false, true, true],
        fontSize: 10,
        colSpan: 1,
      },
      {
        text: ` ${_data?.department?.name || ''}  ${_.map(
          _data?.other_departments,
          (eachDepartment) => `${`\n${eachDepartment?.name}` || ''}`,
        )} `,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'left',
        colSpan: 1,
      },
      {
        text: _data?.earnings?.is_pay_monthy
          ? PAYROLL_TYPE.MONTHY.description
          : PAYROLL_TYPE.DAILY.description,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'center',
        colSpan: 1,
      },
      {
        text: `${currencyFormatterTH.format(_data?.maincost_total)}`,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'right',
        colSpan: 1,
      },
      {
        text: `${currencyFormatterTH.format(_data?.ot_total)}`,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'right',
        colSpan: 1,
      },
      {
        text: `${currencyFormatterTH.format(_data?.payroll_total)}`,
        border: [true, false, true, true],
        fontSize: 10,
        alignment: 'right',
        colSpan: 1,
      },
    ]);

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [20, 30, 40, 20],
    defaultStyle: {
      font: 'Sarabun',
      fontSize: '16',
    },
    info: {
      title: 'รายการค่าตอบแทนพนักงาน',
    },
    content: [
      isError ? ReportHeader(information, false) : ReportHeader(information),
      {
        // หัวข้อ
        alignment: 'center',
        margin: [0, 15, 0, 10],
        text: 'รายการค่าตอบแทนพนักงาน',
        fontSize: '16',
        bold: true,
      },
      option?.filterUsingDate
        ? {
            style: 'tableExample',
            table: {
              widths: ['10%', '35%', '25%', '35%'],
              heights: [15],
              body: [
                [
                  {
                    text: 'วันที่',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      dayjs(option?.selectedDate).format('D MMMM BBBB') || '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? 'ประเภท\nค่าตอบแทน'
                        : '',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? PAYROLL_TYPE[option?.payroll_type]?.description
                        : '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          }
        : {
            style: 'tableExample',
            table: {
              widths: ['15%', '35%', '15%', '35%'],
              heights: [15],
              body: [
                [
                  {
                    text: 'ตั้งแต่วันที่',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: dayjs(option?.startDate).format('D MMMM BBBB') || '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: 'ถึงวันที่',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: dayjs(option?.endDate).format('D MMMM BBBB') || '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
                [
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? 'ประเภท\nค่าตอบแทน'
                        : '',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      option?.payroll_type && option?.payroll_type !== ''
                        ? PAYROLL_TYPE[option?.payroll_type]?.description
                        : '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },

                  {
                    text: '',
                    colSpan: 1,
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: '',
                    colSpan: 1,
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
      {
        margin: [0, 5, 0, 0],
        style: 'tableExample',
        table: {
          widths: ['10%', '*', '20%', '20%', '10%', '10%', '10%'],
          heights: [15],
          body: [
            [
              {
                text: 'ลำดับ',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ชื่อ-นามสกุล',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'แผนก',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ประเภทค่าตอบแทน',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ค่าตอบแทนปกติ',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'ค่าล่วงเวลา',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {
                text: 'รวม',
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
            ],
            ...genEmployee(employees),
            [
              {
                text: 'รวม',
                colSpan: 4,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'center',
              },
              {},
              {},
              {},
              {
                text: currencyFormatterTH.format(
                  _.sum(
                    _.map(
                      employees,
                      (eachEmployee) => eachEmployee?.maincost_total,
                    ),
                  ),
                ),
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'right',
              },
              {
                text: currencyFormatterTH.format(
                  _.sum(
                    _.map(employees, (eachEmployee) => eachEmployee?.ot_total),
                  ),
                ),
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'right',
              },
              {
                text: currencyFormatterTH.format(
                  _.sum(
                    _.map(
                      employees,
                      (eachEmployee) => eachEmployee?.payroll_total,
                    ),
                  ),
                ),
                colSpan: 1,
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                alignment: 'right',
              },
            ],
          ],
        },
      },
    ],
    // images: {
    //   logo: information?.logo?.url,
    // },
  };
  pdfMake.createPdf(docDefinition).open();
};
